module.exports = __webpack_public_path__ + "img/envelope-light.5f87282e.svg";